import { render, staticRenderFns } from "./ViewLog.vue?vue&type=template&id=264dcdba&scoped=true"
import script from "./ViewLog.vue?vue&type=script&lang=js"
export * from "./ViewLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264dcdba",
  null
  
)

export default component.exports